<div
  cdkDrag
  cdkDragDisabled="false"
  cdkDragBoundary=".main-content"
  class="scanner-container small face-scan-positioned"
  [class.minimized]="isMinimized"
  [class.resizing]="isResizing"
  [style.width.px]="customWidth"
  [style.height.px]="customHeight"
  #scannerContainer
>
  <div class="video-header" [class.minimized-header]="isMinimized">
    <div class="drag-handle" cdkDragHandle>
      <div class="dots-grid">
        <span class="dot"></span>
        <span class="dot"></span>
        <span class="dot"></span>
        <span class="dot"></span>
        <span class="dot"></span>
        <span class="dot"></span>
      </div>
    </div>
    <button class="minimize-btn" (click)="toggleMinimize()" [title]="isMinimized ? 'Maximize' : 'Minimize'">
      <span *ngIf="!isMinimized">−</span>
      <span *ngIf="isMinimized">⤢</span>
    </button>
  </div>

  <div class="video-wrapper" [class.hidden-video]="isMinimized">
    <video
      #videoElementExpanded
      autoplay
      muted
      playsinline
      controlsList="nopictureinpicture"
      (contextmenu)="$event.preventDefault()"
    ></video>
  </div>

  <div class="minimized-view" [class.hidden-video]="!isMinimized">
    <video
      #videoElementMinimized
      autoplay
      muted
      playsinline
      controlsList="nopictureinpicture"
      (contextmenu)="$event.preventDefault()"
    ></video>
  </div>

  <!-- Resize handles (only visible when not minimized) -->
  <ng-container *ngIf="!isMinimized">
    <div class="resize-handle resize-handle-e" (mousedown)="startResize($event, 'e')"></div>
    <div class="resize-handle resize-handle-s" (mousedown)="startResize($event, 's')"></div>
    <div class="resize-handle resize-handle-se" (mousedown)="startResize($event, 'se')"></div>
    <div class="resize-handle resize-handle-w" (mousedown)="startResize($event, 'w')"></div>
    <div class="resize-handle resize-handle-n" (mousedown)="startResize($event, 'n')"></div>
    <div class="resize-handle resize-handle-ne" (mousedown)="startResize($event, 'ne')"></div>
    <div class="resize-handle resize-handle-sw" (mousedown)="startResize($event, 'sw')"></div>
    <div class="resize-handle resize-handle-nw" (mousedown)="startResize($event, 'nw')"></div>
  </ng-container>
</div>
